import { render, staticRenderFns } from "./ProductBadges.vue?vue&type=template&id=6d7a874c&scoped=true"
import script from "./ProductBadges.vue?vue&type=script&lang=js"
export * from "./ProductBadges.vue?vue&type=script&lang=js"
import style0 from "./ProductBadges.vue?vue&type=style&index=0&id=6d7a874c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a874c",
  null
  
)

export default component.exports